const startCase = str =>
  str
  .replace(/_/g, ' ')
  .replace(/([a-z])([A-Z])/g, (str, $1, $2) => $1 + ' ' + $2)
  .replace(/(\s|^)(\w)/g, (str, $1, $2) => $1 + $2.toUpperCase())

export default startCase
